import React, { useState } from "react";
import { Alert, Flex, Typography, Button, Modal } from "antd";
import { CloseCircleOutlined, WarningOutlined } from "@ant-design/icons";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../globalAtoms";
import "./styles.scss";
import EditProfile from "components/EditProfile";

const StripeAlerts = () => {
	const user = useRecoilValue(userAtom);
	const isPhoneValid = user?.is_phone_number_valid;

	const [openEditProfile, setOpenEditProfile] = useState(false);
	return (
		<>
			{!isPhoneValid ? (
				<Alert
					message=""
					type="error"
					className="sb-alert-error"
					icon={<CloseCircleOutlined />}
					description={
						<Flex className="sb-alert-description" justify="flex-end" wrap gap={16} align="center">
							<Flex flex={1} gap={16}>
								<WarningOutlined size={24} style={{ fontSize: 24, color: "#DC2626" }} />
								<Typography.Text>Please verify your phone number to secure your account</Typography.Text>
							</Flex>
							<Button color="primary" size="small" variant="solid" onClick={() => setOpenEditProfile(true)}>
								Click here to Verify
							</Button>
						</Flex>
					}
				/>
			) : null}
			<Modal
				open={openEditProfile}
				footer={null}
				title={<Typography.Title level={3}>Edit Profile</Typography.Title>}
				onCancel={() => setOpenEditProfile(false)}
				destroyOnClose
				maskClosable={false}
			>
				<EditProfile activeTab="phone" onCancel={() => setOpenEditProfile(false)} />
			</Modal>
		</>
	);
};

export default StripeAlerts;

